import { render } from "./BackComponent.vue?vue&type=template&id=8cd047de"
import script from "./BackComponent.vue?vue&type=script&lang=js"
export * from "./BackComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__